// extracted by mini-css-extract-plugin
export default {"card":"AboutUs_card__vBc9o","title":"AboutUs_title__vsnx+","text":"AboutUs_text__tKn5Y","text--reversed":"AboutUs_text--reversed__7MZMr"};